<map-advanced-marker #mapAdvancedMarker="mapAdvancedMarker"
                     [options]="markerOptions"
                     [position]="marker().position"
                     [content]="pin"
                     [zIndex]="zIndex()"
                     [title]="title()"
                     [gmpDraggable]="gmpDraggable()"
                     (mapClick)="onMarkerClick()"
                     (mapDrag)="markerDrag.emit($event)">
  <img #pin
       [src]="getCvMarkerUrl(marker().type === cvMarkerType.HISTORY ?
                validationHistoryItem()?.source :
                marker().type,
              isVerifiedMarker(marker().id),
              isMinimized())"
       alt="marker pin"
       (mouseover)="markerMouseover.emit()"
       (mouseout)="markerMouseout.emit()"
       [style.opacity]="marker().type === cvMarkerType.HISTORY ? 0.7 : 1">
</map-advanced-marker>
